var _defs, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaignoireBonnePosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baignoire",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 891 374.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-width:5px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bagnoire bonne r\xE9ponse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467,1283h576s179,11,179-303H336C336,1146,384,1283,467,1283Z",
    transform: "translate(-333.5 -977.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 437.5,
    y: 128.5,
    width: 297,
    height: 148
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bonne"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 735.84,
    cy: 291.84,
    r: 79.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M589.76,1309.45l96.68-125.26,58.24,59.33c36.25,39.56,12.37,56.57,31.86,71.42s26.83-.38,61.53,1.1l95.31,20.36c74.64-15.37,60.7-133.53,38.73-140.12S862,1182,862,1182l-10-24c-8-22-31-12-32,6l-1,42,49.83,18.85-82.4,4.39s-36.82-89.22-75.24-124.51c-7.25-6.67-28.29-6.68-33.54-.74-25.27,28.56-128.54,182.38-128.54,182.38C540.32,1322.63,583.17,1325.93,589.76,1309.45Z",
    transform: "translate(-333.5 -977.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M671.09,1319.84,720,1183l6.92,54.31c13.79,81.83,50.17,98.84,119.56,101.8l117.67-2.71c74.63-15.37,60.7-133.53,38.72-140.12S917,1175,917,1175l-11-22c-6-15-31-21-33,5l-2,41,47.27,11.56-106.57,5.5s-31.32-76-69.75-111.33c-7.25-6.67-28.28-6.68-33.53-.74-25.27,28.56-78,192.78-78,192.78C621.65,1333,664.5,1336.32,671.09,1319.84Z",
    transform: "translate(-333.5 -977.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaignoireBonnePosition);
export default __webpack_public_path__ + "static/media/baignoire_bonne_position.89eb18ca1291dc312e3efdbba3309fb8.svg";
export { ForwardRef as ReactComponent };